import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { c as classNames } from '../shared/index-324f55b0.js';

function resolveSides(p) {
  var _p$paddingX, _p$paddingY, _p$paddingTop, _p$paddingRight, _p$paddingBottom, _p$paddingLeft;
  var all = p.padding;
  var x = (_p$paddingX = p.paddingX) !== null && _p$paddingX !== void 0 ? _p$paddingX : all;
  var y = (_p$paddingY = p.paddingY) !== null && _p$paddingY !== void 0 ? _p$paddingY : all;
  return {
    pt: (_p$paddingTop = p.paddingTop) !== null && _p$paddingTop !== void 0 ? _p$paddingTop : y,
    pr: (_p$paddingRight = p.paddingRight) !== null && _p$paddingRight !== void 0 ? _p$paddingRight : x,
    pb: (_p$paddingBottom = p.paddingBottom) !== null && _p$paddingBottom !== void 0 ? _p$paddingBottom : y,
    pl: (_p$paddingLeft = p.paddingLeft) !== null && _p$paddingLeft !== void 0 ? _p$paddingLeft : x
  };
}
function getPaddingClasses(styles, componentClass, p) {
  var _resolveSides = resolveSides(p),
    pt = _resolveSides.pt,
    pr = _resolveSides.pr,
    pb = _resolveSides.pb,
    pl = _resolveSides.pl;
  var classes = {};
  if (typeof componentClass !== 'string' || _trimInstanceProperty(componentClass).call(componentClass) === '') return '';
  if (!pt && !pr && !pb && !pl) return '';
  if (pt && pr && pb && pl && pt === pr && pr === pb && pb === pl) {
    var _context;
    classes[styles[_concatInstanceProperty(_context = "".concat(componentClass, "--p-")).call(_context, pt)]] = true;
    return classNames(classes);
  }
  if (pr && pl && pr === pl) {
    var _context2;
    classes[styles[_concatInstanceProperty(_context2 = "".concat(componentClass, "--px-")).call(_context2, pr)]] = true;
  } else {
    var _context3, _context4;
    if (pr) classes[styles[_concatInstanceProperty(_context3 = "".concat(componentClass, "--pr-")).call(_context3, pr)]] = true;
    if (pl) classes[styles[_concatInstanceProperty(_context4 = "".concat(componentClass, "--pl-")).call(_context4, pl)]] = true;
  }
  if (pt && pb && pt === pb) {
    var _context5;
    classes[styles[_concatInstanceProperty(_context5 = "".concat(componentClass, "--py-")).call(_context5, pt)]] = true;
  } else {
    var _context6, _context7;
    if (pt) classes[styles[_concatInstanceProperty(_context6 = "".concat(componentClass, "--pt-")).call(_context6, pt)]] = true;
    if (pb) classes[styles[_concatInstanceProperty(_context7 = "".concat(componentClass, "--pb-")).call(_context7, pb)]] = true;
  }
  return classNames(classes);
}

export { getPaddingClasses };
//# sourceMappingURL=padding.js.map
